import { useState } from "react";

export interface FaqItem {
  q: string;
  a: string;
}

interface FaqAccordionProps {
  items: FaqItem[];
  defaultOpen?: number;
}

export default function FaqAccordion({ items, defaultOpen = -1 }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number>(defaultOpen);

  const toggle = (index: number) => {
    setOpenIndex((current) => (current === index ? -1 : index));
  };

  return (
    <div className="divide-y divide-background-200 border-y border-background-200">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.q}>
            <h4 className="text-base md:text-lg">
              <button
                type="button"
                onClick={() => toggle(index)}
                aria-expanded={isOpen}
                className="w-full flex items-start justify-between gap-4 py-5 text-left cursor-pointer group"
              >
                <span
                  className={`font-heading font-bold leading-snug transition-colors ${
                    isOpen ? "text-primary-600" : "text-foreground-950 group-hover:text-primary-600"
                  }`}
                >
                  {item.q}
                </span>
                <span className="mt-0.5 w-7 h-7 rounded-full border border-background-300 flex items-center justify-center shrink-0 text-foreground-700 group-hover:border-primary-300 transition-colors">
                  <i
                    className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-base`}
                    aria-hidden="true"
                  ></i>
                </span>
              </button>
            </h4>
            {isOpen && (
              <div className="pb-5 pr-10 animate-fade">
                <p className="text-sm md:text-[15px] text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}